import { useGetCatalogQuery } from '@platform/state/api';
import { useLabel } from '@platform/hooks/useLabel';
import { ModuleTile } from '@platform/ui';
import { moduleNav } from '@platform/navigation';
import type { IHomeViewGroupProps } from './IHomeViewGroupProps';
import { HomeViewRow } from './HomeViewRow';

/**
 * Група подання «Моя робота» (прототип v4 G:L1597): картка з радіусом 12, шапка на --surface2 — плитка модуля 24px, назва 600, кількість.
 * Назва — як «модуль» прототипу: головний тип — назва модуля («CRM»), дочірній — назва типу («Контакти»).
 */
export function HomeViewGroup({ ws, group, today }: IHomeViewGroupProps) {
  const label = useLabel();
  const { data: catalog } = useGetCatalogQuery({ workspaceId: ws });
  const nav = moduleNav(group.module);
  const summary = catalog?.modules.find((m) => m.key === group.module);
  const type = summary?.recordTypes.find((r) => r.key === group.recordType);
  const name = (type && !type.main ? label(type.name) : label(summary?.name)) || group.recordType;
  return (
    <section className="hv-group" aria-label={name}>
      <div className="hv-group__head">
        <ModuleTile icon={nav.icon} tone={nav.tone} size={24} />
        <strong className="hv-group__name">{name}</strong>
        <span className="hv-group__count">{group.items.length}</span>
      </div>
      {group.items.map((r) => <HomeViewRow key={`${r.recordType}:${r.id}`} record={r} today={today} />)}
    </section>
  );
}
